import FormHelperText from '@mui/material/FormHelperText';
import { DatePicker, DatePickerProps, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TProps = DatePickerProps<any> & {
  name: string;
  helperText?: string;
};

export const RHFDatePicker: FC<TProps> = props => {
  const { name, helperText, sx, ...others } = props;

  const { control } = useFormContext();

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <Controller
        name={name}
        control={control}
        render={({ field: { onBlur, onChange, ...rest }, fieldState: { error } }) => {
          return (
            <>
              <DatePicker
                {...others}
                {...rest}
                onChange={(value: unknown) => {
                  onChange(value);
                  onBlur();
                }}
                name={name}
                sx={{
                  width: '100%',
                  ...sx,
                }}
              />

              {(!!error || helperText) && (
                <FormHelperText error={!!error}>{error ? error?.message : helperText}</FormHelperText>
              )}
            </>
          );
        }}
      />
    </LocalizationProvider>
  );
};
